import { loadMoreMessages } from '../actions/chat-actions';

export const scrollToBottom = (container) => {
    if (container) {
        const scrollHeight = container && container.scrollHeight;
        const height = container && container.clientHeight;
        const maxScrollTop = scrollHeight - height;
        container.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
    } 
    // TODO: ========= 
        // might be good to show an indicator when a new message arrives while the user is scrolled up looking at chat history so they know to scroll down to view the new message. 
        // I dont like the idea of forcing a scroll down when they are viewing old messages.
        // They can click on the indicator to scroll to the bottom/new messages and hide the indicator
        // ===============
}

// export const loadPreviousMessages = (isVisible) => {
//     console.log('I AM VISIBLE', this.props.messagesRedux.length, this.props.allowedToLoadPrevious)
//     if (this.props.messagesRedux.length > 19 /*&& this.props.allowedToLoadPrevious*/) {
//         console.log('IS VISIBLE?', isVisible, this.state.loadingPrevious);
//         if (!isVisible || /*!this.props.allowedToLoadPrevious ||*/ this.state.loadingPrevious) return;
        
//         // console.log('COUNT CALC (count/count*19/length/nodeindex)', this.state.count, this.state.count * 19, this.props.messages.length - 1, this.props.messages.length - 1 - (this.state.count * 19));
//         // const allmess = document.querySelectorAll(".messages .message");
//         // console.log('MESSAGES', allmess );

//         this.setState((prevState) => {
//             return {
//                 loadingPrevious: true,
//                 count: prevState.count + 1
//             } 
//         });

//         return loadMoreMessages()
//             .then((previousMessages) => {
//                 console.log('PREV MESS', previousMessages, previousMessages.length, document.querySelectorAll('.messages .message'));
                
//                 let lastLoadedMessage = document.querySelectorAll('.messages .message')[previousMessages.length];

//                 process.nextTick(()=>{
//                     lastLoadedMessage.parentNode.scrollTop = lastLoadedMessage.offsetTop - lastLoadedMessage.parentNode.offsetTop;
                    
//                     this.convertLinks();
//                     return this.setState({
//                         loadingPrevious: false
//                     });
//                 });
//             })
//             .catch(console.log);
//     }
// }


// WEBPACK FOOTER //
// ./src/js/utils/messagingUtils.js